import * as Stimulus from "@hotwired/stimulus"

export class PasswordConfirmationController extends Stimulus.Controller {
    static get targets() {
        return [ 'new', 'confirm' ];
    }

    static values = {
        errorMessage: { type: String, default: 'Passwords do not match' }
    }

    connect() {
        DEV: this.#assertConfiguration();
    }

    validate(e) {
        DEV: this.#assertConfiguration();

        if(this.newTarget.value == '' || this.confirmTarget.value == '') {
            // Don't do anything if either field is empty so that the
            // user doesn't see an error when first filling out the form
            return;
        }

        if(this.newTarget.checkValidity() && this.newTarget.value !== this.confirmTarget.value) {
            this.dispatch("invalid", { prefix: "form", detail: { errorMessage: this.errorMessageValue}});
            e.stopImmediatePropagation();
            e.preventDefault();
        }
    }

    #assertConfiguration() {
        this.newTarget.value;
        this.confirmTarget.value;
    }
}
